"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    announcements: {
        whatIsNew: 'Announcements & Help Center',
        goToWhatIsNew: "Go to what's new",
    },
};
